module.exports = __webpack_public_path__ + "static/media/table_background_large.9928ff5a.jpg";